module.exports = __webpack_public_path__ + "static/media/gerl.94e9408b.webp";